import { createFileRoute } from '@tanstack/react-router';
import { VirtualCounterPage } from '@/components/VirtualCounterPage';
import { ProductRouteGuard } from '@/components/ProductRouteGuard';

export const Route = createFileRoute('/_authenticated/ventanilla-virtual/')({ component: VirtualCounterRoute });

function VirtualCounterRoute(): JSX.Element {
  return (
    <ProductRouteGuard
      products={['Estudio', 'Empresa']}
      requirePermission="canManageAfip"
      title="Ventanilla virtual no disponible"
      description="Seleccioná un producto fiscal con permisos ARCA para consultar la ventanilla virtual."
    >
      <VirtualCounterPage />
    </ProductRouteGuard>
  );
}
